import React from 'react'
import Container from 'src/Home/Container'
import { RouteComponentProps } from 'react-router-dom'

const Home = (props: RouteComponentProps) => {
  return <Container props={props} />
}

export default Home
